import {parseJwt, Signing, verifyJwt, sha256} from "@credify/crypto";
import { PublicKeyResponse } from "@credify/api-docs/apiClients/v1";
import { CredifyClass } from "./common";
import {ecosystemId } from "./config";

export class Auth extends CredifyClass {
  /**
   * Introspects access token
   * @param token
   * @param scope
   */
  public async introspectToken(token: string, scope: string): Promise<boolean> {
    const body = {
      token,
      scope,
    };
    try {
      const res = await this.apiClient.post("v1/oauth2/introspect", body);
      const resBody = res.data;
      // @ts-ignore
      return resBody?.data?.active === true;
    } catch(e: any) {
      return false;
    }
  }

  /**
   * Introspects an access token with the result returning
   * @param token
   * @returns Promise<any> Any here should be a json object with the schema like { data: { active: true, client_id: '', scope: '', ... } }
   */
  public async introspectTokenReturnResult(token: string): Promise<any> {
    const body = {
      token,
    };
    const res = await this.apiClient.post("v1/oauth2/introspect", body);
    return res.data;
  }

  /**
   * Verifies webhook that is sent by Credify.
   * This function checks if the signature is actually signed by Credify.
   * @param signature You can get it from webhook HTTP request header
   * @param body Webhook HTTP request body
   * @param endpoint You can get it from webhook HTTP request header
   * @param eventId You can get it from webhook HTTP request header
   * @param timestamp You can get it from webhook HTTP request header
   * @returns Promise<boolean> Whether this request is valid or not.
   */
  public async verifyWebhook(signature: string, body: object, endpoint: string, eventId: string, timestamp: string): Promise<boolean> {
    const id = ecosystemId(this.config);
    const ecosystemKey = await this.apiClient.get<
      PublicKeyResponse
      >(`v1/entity/public-key?entity_id=${id}`);
    const pub = ecosystemKey.data.data?.signing || "";
    if (pub === "") {
      throw new Error("Public key is not found.");
    }

    const s = new Signing();
    s.importPublicKey(pub);

    const method = "POST";
    const payload = sha256(body);
    const message = `${method}\n${endpoint}\n${eventId}\n${timestamp}\n${payload}`;

    const valid = s.verify(message, signature, { encode: "base64Url" });
    if (!valid) {
      throw new Error("Signature of webhook request is not valid.");
    }

    return true;
  }
}
